import { Box, Button, IconButton } from "@mui/material";
import { IconBadge } from "components/Icons";
import CustomSnackbar from "components/ToastMessage/CustomSnackbarToast";
import { useSnackbar } from "components/ToastMessage/useSnackbar";
import { useSendClick } from "hooks/fetch/useSendClick";
import { useBreak } from "hooks/useBreak";
import PropTypes from "prop-types";
import React, { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { getFocus, useAtom, useGet } from "state/jotai";
import { active_project, compares } from "state/store.global";
import { _project } from "state/store.projects";

function ButtonCompare({ unitId, iconOnly, label,atUnit }) {
  const { showSnackbar } = useSnackbar();
  const [comps, setComps] = useAtom(compares);
  const [count, setCount] = useState("");
  const isComps = comps.includes(unitId)
  const isMobile = useBreak("md_dn");
   
   
  const buttonTextColor = isMobile || !atUnit? "#000000" : clr?.buttons_text ;
  // State for Snackbar
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');

  const sendClick = useSendClick();

  // Function to open Snackbar
  const handleSnackbarOpen = (message) => {
    setSnackbarMessage(message);
    setSnackbarOpen(true);
  };

  // Function to close Snackbar
  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarOpen(false);
  };

  const { pin, pid } = useGet(active_project)
  const buttonsLabel = getFocus(_project, 'buttonsLabel')?.[pin]?.[pid] ?? []

  useEffect(() => {
    if (comps.includes(unitId)) {
      setCount(comps.indexOf(unitId) + 1);
    } else {
      setCount("");
    }
  }, [unitId, comps]);

  const handleClick = useCallback(
    (e) => {
      e.stopPropagation();

          sendClick(isComps ? "unit_compare_removed" : "compare_button", {
            unitID: unitId,
          });
          
      if (comps.includes(unitId)) {
        // remove from list.
        const list = comps.filter((i) => i !== unitId);
        setComps(list);
      } else {
        // add to list.
        const list = [...comps];
        if (3 === comps.length) {
          // max 3 items, remove an item.
          list.pop();
        }
        list.push(unitId);
        setComps(list);
      }

      if(3 !== comps.length) {
        showSnackbar(isComps ? buttonsLabel?.filter(
          (btn) => btn.UILabelProperty === "ToastRemovedforComparison"
        )[0]?.Label : buttonsLabel?.filter(
          (btn) => btn.UILabelProperty === "ToastAddedtoComparison"
        )[0]?.Label);
      }
    },
    [comps, unitId]
  );

  return (
    <>
      {iconOnly ? (
        <IconButton onClick={handleClick}>
          <IconBadge icon="compare" badge={count} style={{ fontSize: "20px", color: buttonTextColor }} isFaIcon={true} size={'sm'} />
        </IconButton>
      ) : (
        <Button
          type="button"
          onClick={handleClick}
          color="inherit"
          disableRipple
          disableFocusRipple
          startIcon={<IconBadge icon="compare" badge={count} style={{ fontSize: "20px", color: buttonTextColor }} isFaIcon={true} size={'sm'} />}
          sx={{
            padding: 0,
            minWidth: 0,
            background: "none",
            boxShadow: "none",
            "&:hover": {
              background: "none",
            },
          }}
        >
          <Box component="span" className="paragraph1-regular" style={{ color: buttonTextColor }}>
            {comps.includes(unitId) ? `${buttonsLabel?.filter(btn => btn.UILabelProperty === 'Tilføjet')[0]?.Label}` : `${buttonsLabel?.filter(btn => btn.UILabelProperty === 'Sammenlign')[0]?.Label}`}
          </Box>
        </Button>

      )}

      <CustomSnackbar message={snackbarMessage} onClose={handleSnackbarClose} open={snackbarOpen} />

    </>
  );
}

ButtonCompare.propTypes = {
  unitId: PropTypes.number.isRequired,
  iconOnly: PropTypes.bool,
  atUnit: PropTypes.bool,
};

export default ButtonCompare;
